<script lang="ts">
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import {
        meetingGroupsStore,
        type MeetingGroup,
        type SpaceMeetingGroup,
        type AnyMeetingGroup,
    } from "../../Stores/MeetingGroupsStore";
    import { LL } from "../../../../i18n/i18n-svelte";
    import Avatar from "../Avatar.svelte";
    import { IconArrowRight, IconUsersGroup, IconCamera } from "@wa-icons";

    function goToMeetingGroup(group: MeetingGroup) {
        const gameScene = gameManager.getCurrentGameScene();
        if (!gameScene || !gameScene.connection) return;
        const firstParticipant = group.participants[0];
        if (!firstParticipant) return;
        gameScene.connection.emitAskPosition(firstParticipant.uuid, gameScene.roomUrl);
    }

    function isMeetingGroup(group: AnyMeetingGroup): group is MeetingGroup {
        return "groupId" in group;
    }

    function isSpaceGroup(group: AnyMeetingGroup): group is SpaceMeetingGroup {
        return "spaceName" in group;
    }
</script>

{#if $meetingGroupsStore.length > 0}
    <div class="flex flex-col shrink-0 border-b border-white/10">
        <div class="px-3 pt-3 pb-1 flex items-center gap-2">
            <IconUsersGroup font-size="16" class="text-white/75" />
            <div class="text-white text-sm font-bold tracking-widest uppercase grow text-start">
                {$LL.chat.meetings.title()} ({$meetingGroupsStore.length})
            </div>
        </div>
        {#each $meetingGroupsStore as group, i (isMeetingGroup(group) ? `bubble:${group.groupId}:${i}` : `space:${group.spaceName}:${i}`)}
            <div class="flex flex-col px-3 py-2 gap-1.5">
                {#if isMeetingGroup(group) && group.zoneName}
                    <div
                        class="text-xs font-semibold text-white/60 uppercase tracking-wide truncate"
                        title={group.zoneName}
                    >
                        {group.zoneName}
                    </div>
                {/if}
                {#if isSpaceGroup(group)}
                    <div
                        class="flex items-center gap-1.5 text-xs font-semibold text-white/60 uppercase tracking-wide truncate"
                    >
                        <IconCamera font-size="14" />
                        <span title={group.zoneName || group.spaceName}>
                            {group.zoneName || group.spaceName}
                        </span>
                    </div>
                {/if}
                <div class="flex items-center gap-2 flex-wrap">
                    {#each group.participants as participant, i (participant.uuid + ":" + i)}
                        <div class="flex items-center gap-1.5" title={participant.name}>
                            <Avatar compact pictureStore={participant.pictureStore} fallbackName={participant.name} />
                            <span class="text-sm text-white/90 font-medium truncate max-w-[80px]">
                                {participant.name}
                            </span>
                        </div>
                    {/each}
                </div>
                {#if isMeetingGroup(group)}
                    <button
                        class="flex items-center gap-1.5 px-2 py-1 rounded bg-white/10 hover:bg-white/20 text-white/80 hover:text-white text-xs font-medium transition-colors self-start m-0 border-0 cursor-pointer"
                        onclick={() => goToMeetingGroup(group)}
                    >
                        <IconArrowRight font-size="14" />
                        {$LL.chat.meetings.goToMeeting()}
                    </button>
                {/if}
            </div>
        {/each}
    </div>
{/if}
